// Protocol Buffers for Analytics Services
// 
// Package: guardianai.v1.analytics

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/analytics/analytics.proto (package guardianai.v1.analytics, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/analytics/analytics.proto.
 */
export const file_guardianai_v1_analytics_analytics: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.analytics.DashboardAnalyticsRequest
 */
export type DashboardAnalyticsRequest = Message<"guardianai.v1.analytics.DashboardAnalyticsRequest"> & {
  /**
   * "day", "week", "month", "quarter", "year"
   *
   * @generated from field: string period = 1;
   */
  period: string;

  /**
   * @generated from field: repeated string metrics = 2;
   */
  metrics: string[];
};

/**
 * @generated from message guardianai.v1.analytics.DashboardAnalyticsRequest
 */
export type DashboardAnalyticsRequestJson = {
  /**
   * "day", "week", "month", "quarter", "year"
   *
   * @generated from field: string period = 1;
   */
  period?: string;

  /**
   * @generated from field: repeated string metrics = 2;
   */
  metrics?: string[];
};

/**
 * Describes the message guardianai.v1.analytics.DashboardAnalyticsRequest.
 * Use `create(DashboardAnalyticsRequestSchema)` to create a new message.
 */
export const DashboardAnalyticsRequestSchema: GenMessage<DashboardAnalyticsRequest, {jsonType: DashboardAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 0);

/**
 * @generated from message guardianai.v1.analytics.DashboardAnalyticsResponse
 */
export type DashboardAnalyticsResponse = Message<"guardianai.v1.analytics.DashboardAnalyticsResponse"> & {
  /**
   * @generated from field: map<string, double> metrics = 1;
   */
  metrics: { [key: string]: number };

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint time_series = 2;
   */
  timeSeries: TimeSeriesPoint[];

  /**
   * @generated from field: map<string, int64> counters = 3;
   */
  counters: { [key: string]: bigint };

  /**
   * Additional fields for frontend compatibility
   *
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trends = 4;
   */
  trends: TimeSeriesPoint[];

  /**
   * @generated from field: guardianai.v1.analytics.TrustScoreAnalytics trust_score_analytics = 5;
   */
  trustScoreAnalytics?: TrustScoreAnalytics;

  /**
   * @generated from field: guardianai.v1.analytics.InvestigatorPerformance investigator_performance = 6;
   */
  investigatorPerformance?: InvestigatorPerformance;

  /**
   * @generated from field: guardianai.v1.analytics.InvestigationMetrics investigation_metrics = 7;
   */
  investigationMetrics?: InvestigationMetrics;
};

/**
 * @generated from message guardianai.v1.analytics.DashboardAnalyticsResponse
 */
export type DashboardAnalyticsResponseJson = {
  /**
   * @generated from field: map<string, double> metrics = 1;
   */
  metrics?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint time_series = 2;
   */
  timeSeries?: TimeSeriesPointJson[];

  /**
   * @generated from field: map<string, int64> counters = 3;
   */
  counters?: { [key: string]: string };

  /**
   * Additional fields for frontend compatibility
   *
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trends = 4;
   */
  trends?: TimeSeriesPointJson[];

  /**
   * @generated from field: guardianai.v1.analytics.TrustScoreAnalytics trust_score_analytics = 5;
   */
  trustScoreAnalytics?: TrustScoreAnalyticsJson;

  /**
   * @generated from field: guardianai.v1.analytics.InvestigatorPerformance investigator_performance = 6;
   */
  investigatorPerformance?: InvestigatorPerformanceJson;

  /**
   * @generated from field: guardianai.v1.analytics.InvestigationMetrics investigation_metrics = 7;
   */
  investigationMetrics?: InvestigationMetricsJson;
};

/**
 * Describes the message guardianai.v1.analytics.DashboardAnalyticsResponse.
 * Use `create(DashboardAnalyticsResponseSchema)` to create a new message.
 */
export const DashboardAnalyticsResponseSchema: GenMessage<DashboardAnalyticsResponse, {jsonType: DashboardAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 1);

/**
 * @generated from message guardianai.v1.analytics.TrustScoreAnalytics
 */
export type TrustScoreAnalytics = Message<"guardianai.v1.analytics.TrustScoreAnalytics"> & {
  /**
   * @generated from field: double average_score = 1;
   */
  averageScore: number;

  /**
   * Alias for average_score for frontend
   *
   * @generated from field: double average_trust_score = 2;
   */
  averageTrustScore: number;

  /**
   * @generated from field: double score_change = 3;
   */
  scoreChange: number;

  /**
   * @generated from field: int64 scans_performed = 4;
   */
  scansPerformed: bigint;

  /**
   * @generated from field: int64 low_trust_alerts = 5;
   */
  lowTrustAlerts: bigint;

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint score_trend = 6;
   */
  scoreTrend: TimeSeriesPoint[];

  /**
   * @generated from field: map<string, int64> by_category = 7;
   */
  byCategory: { [key: string]: bigint };

  /**
   * @generated from field: double median_trust_score = 8;
   */
  medianTrustScore: number;

  /**
   * Score distribution buckets
   *
   * @generated from field: map<string, int64> distribution = 9;
   */
  distribution: { [key: string]: bigint };

  /**
   * @generated from field: double min_trust_score = 10;
   */
  minTrustScore: number;

  /**
   * @generated from field: double max_trust_score = 11;
   */
  maxTrustScore: number;
};

/**
 * @generated from message guardianai.v1.analytics.TrustScoreAnalytics
 */
export type TrustScoreAnalyticsJson = {
  /**
   * @generated from field: double average_score = 1;
   */
  averageScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Alias for average_score for frontend
   *
   * @generated from field: double average_trust_score = 2;
   */
  averageTrustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double score_change = 3;
   */
  scoreChange?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 scans_performed = 4;
   */
  scansPerformed?: string;

  /**
   * @generated from field: int64 low_trust_alerts = 5;
   */
  lowTrustAlerts?: string;

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint score_trend = 6;
   */
  scoreTrend?: TimeSeriesPointJson[];

  /**
   * @generated from field: map<string, int64> by_category = 7;
   */
  byCategory?: { [key: string]: string };

  /**
   * @generated from field: double median_trust_score = 8;
   */
  medianTrustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Score distribution buckets
   *
   * @generated from field: map<string, int64> distribution = 9;
   */
  distribution?: { [key: string]: string };

  /**
   * @generated from field: double min_trust_score = 10;
   */
  minTrustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double max_trust_score = 11;
   */
  maxTrustScore?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.analytics.TrustScoreAnalytics.
 * Use `create(TrustScoreAnalyticsSchema)` to create a new message.
 */
export const TrustScoreAnalyticsSchema: GenMessage<TrustScoreAnalytics, {jsonType: TrustScoreAnalyticsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 2);

/**
 * @generated from message guardianai.v1.analytics.InvestigatorPerformance
 */
export type InvestigatorPerformance = Message<"guardianai.v1.analytics.InvestigatorPerformance"> & {
  /**
   * @generated from field: string investigator_id = 1;
   */
  investigatorId: string;

  /**
   * @generated from field: int64 cases_resolved = 2;
   */
  casesResolved: bigint;

  /**
   * @generated from field: int64 cases_pending = 3;
   */
  casesPending: bigint;

  /**
   * @generated from field: double resolution_rate = 4;
   */
  resolutionRate: number;

  /**
   * @generated from field: double avg_resolution_time_hours = 5;
   */
  avgResolutionTimeHours: number;

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trend = 6;
   */
  trend: TimeSeriesPoint[];

  /**
   * @generated from field: double user_rating = 7;
   */
  userRating: number;
};

/**
 * @generated from message guardianai.v1.analytics.InvestigatorPerformance
 */
export type InvestigatorPerformanceJson = {
  /**
   * @generated from field: string investigator_id = 1;
   */
  investigatorId?: string;

  /**
   * @generated from field: int64 cases_resolved = 2;
   */
  casesResolved?: string;

  /**
   * @generated from field: int64 cases_pending = 3;
   */
  casesPending?: string;

  /**
   * @generated from field: double resolution_rate = 4;
   */
  resolutionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double avg_resolution_time_hours = 5;
   */
  avgResolutionTimeHours?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trend = 6;
   */
  trend?: TimeSeriesPointJson[];

  /**
   * @generated from field: double user_rating = 7;
   */
  userRating?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.analytics.InvestigatorPerformance.
 * Use `create(InvestigatorPerformanceSchema)` to create a new message.
 */
export const InvestigatorPerformanceSchema: GenMessage<InvestigatorPerformance, {jsonType: InvestigatorPerformanceJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 3);

/**
 * @generated from message guardianai.v1.analytics.InvestigationMetrics
 */
export type InvestigationMetrics = Message<"guardianai.v1.analytics.InvestigationMetrics"> & {
  /**
   * @generated from field: int64 total_investigations = 1;
   */
  totalInvestigations: bigint;

  /**
   * @generated from field: int64 active_investigations = 2;
   */
  activeInvestigations: bigint;

  /**
   * @generated from field: int64 completed_investigations = 3;
   */
  completedInvestigations: bigint;

  /**
   * @generated from field: int64 pending_investigations = 4;
   */
  pendingInvestigations: bigint;

  /**
   * @generated from field: double avg_duration_hours = 5;
   */
  avgDurationHours: number;

  /**
   * @generated from field: double success_rate = 6;
   */
  successRate: number;

  /**
   * Investigation counts by status
   *
   * @generated from field: map<string, int64> by_status = 7;
   */
  byStatus: { [key: string]: bigint };
};

/**
 * @generated from message guardianai.v1.analytics.InvestigationMetrics
 */
export type InvestigationMetricsJson = {
  /**
   * @generated from field: int64 total_investigations = 1;
   */
  totalInvestigations?: string;

  /**
   * @generated from field: int64 active_investigations = 2;
   */
  activeInvestigations?: string;

  /**
   * @generated from field: int64 completed_investigations = 3;
   */
  completedInvestigations?: string;

  /**
   * @generated from field: int64 pending_investigations = 4;
   */
  pendingInvestigations?: string;

  /**
   * @generated from field: double avg_duration_hours = 5;
   */
  avgDurationHours?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double success_rate = 6;
   */
  successRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Investigation counts by status
   *
   * @generated from field: map<string, int64> by_status = 7;
   */
  byStatus?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.analytics.InvestigationMetrics.
 * Use `create(InvestigationMetricsSchema)` to create a new message.
 */
export const InvestigationMetricsSchema: GenMessage<InvestigationMetrics, {jsonType: InvestigationMetricsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 4);

/**
 * @generated from message guardianai.v1.analytics.TimeSeriesPoint
 */
export type TimeSeriesPoint = Message<"guardianai.v1.analytics.TimeSeriesPoint"> & {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp: bigint;

  /**
   * @generated from field: double value = 2;
   */
  value: number;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * @generated from message guardianai.v1.analytics.TimeSeriesPoint
 */
export type TimeSeriesPointJson = {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp?: string;

  /**
   * @generated from field: double value = 2;
   */
  value?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string label = 3;
   */
  label?: string;
};

/**
 * Describes the message guardianai.v1.analytics.TimeSeriesPoint.
 * Use `create(TimeSeriesPointSchema)` to create a new message.
 */
export const TimeSeriesPointSchema: GenMessage<TimeSeriesPoint, {jsonType: TimeSeriesPointJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 5);

/**
 * @generated from message guardianai.v1.analytics.UserAnalyticsRequest
 */
export type UserAnalyticsRequest = Message<"guardianai.v1.analytics.UserAnalyticsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.analytics.UserAnalyticsRequest
 */
export type UserAnalyticsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string period = 2;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.analytics.UserAnalyticsRequest.
 * Use `create(UserAnalyticsRequestSchema)` to create a new message.
 */
export const UserAnalyticsRequestSchema: GenMessage<UserAnalyticsRequest, {jsonType: UserAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 6);

/**
 * @generated from message guardianai.v1.analytics.UserAnalyticsResponse
 */
export type UserAnalyticsResponse = Message<"guardianai.v1.analytics.UserAnalyticsResponse"> & {
  /**
   * @generated from field: int64 total_scans = 1;
   */
  totalScans: bigint;

  /**
   * @generated from field: int64 fraud_reported = 2;
   */
  fraudReported: bigint;

  /**
   * @generated from field: int64 fraud_detected = 3;
   */
  fraudDetected: bigint;

  /**
   * @generated from field: double avg_trust_score = 4;
   */
  avgTrustScore: number;

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint activity = 5;
   */
  activity: TimeSeriesPoint[];
};

/**
 * @generated from message guardianai.v1.analytics.UserAnalyticsResponse
 */
export type UserAnalyticsResponseJson = {
  /**
   * @generated from field: int64 total_scans = 1;
   */
  totalScans?: string;

  /**
   * @generated from field: int64 fraud_reported = 2;
   */
  fraudReported?: string;

  /**
   * @generated from field: int64 fraud_detected = 3;
   */
  fraudDetected?: string;

  /**
   * @generated from field: double avg_trust_score = 4;
   */
  avgTrustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint activity = 5;
   */
  activity?: TimeSeriesPointJson[];
};

/**
 * Describes the message guardianai.v1.analytics.UserAnalyticsResponse.
 * Use `create(UserAnalyticsResponseSchema)` to create a new message.
 */
export const UserAnalyticsResponseSchema: GenMessage<UserAnalyticsResponse, {jsonType: UserAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 7);

/**
 * @generated from message guardianai.v1.analytics.FraudAnalyticsRequest
 */
export type FraudAnalyticsRequest = Message<"guardianai.v1.analytics.FraudAnalyticsRequest"> & {
  /**
   * @generated from field: string period = 1;
   */
  period: string;

  /**
   * @generated from field: repeated string fraud_types = 2;
   */
  fraudTypes: string[];

  /**
   * @generated from field: repeated string regions = 3;
   */
  regions: string[];
};

/**
 * @generated from message guardianai.v1.analytics.FraudAnalyticsRequest
 */
export type FraudAnalyticsRequestJson = {
  /**
   * @generated from field: string period = 1;
   */
  period?: string;

  /**
   * @generated from field: repeated string fraud_types = 2;
   */
  fraudTypes?: string[];

  /**
   * @generated from field: repeated string regions = 3;
   */
  regions?: string[];
};

/**
 * Describes the message guardianai.v1.analytics.FraudAnalyticsRequest.
 * Use `create(FraudAnalyticsRequestSchema)` to create a new message.
 */
export const FraudAnalyticsRequestSchema: GenMessage<FraudAnalyticsRequest, {jsonType: FraudAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 8);

/**
 * @generated from message guardianai.v1.analytics.FraudAnalyticsResponse
 */
export type FraudAnalyticsResponse = Message<"guardianai.v1.analytics.FraudAnalyticsResponse"> & {
  /**
   * @generated from field: int64 total_cases = 1;
   */
  totalCases: bigint;

  /**
   * @generated from field: int64 resolved_cases = 2;
   */
  resolvedCases: bigint;

  /**
   * @generated from field: int64 pending_cases = 3;
   */
  pendingCases: bigint;

  /**
   * @generated from field: double detection_rate = 4;
   */
  detectionRate: number;

  /**
   * @generated from field: map<string, int64> by_type = 5;
   */
  byType: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> by_region = 6;
   */
  byRegion: { [key: string]: bigint };

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trend = 7;
   */
  trend: TimeSeriesPoint[];
};

/**
 * @generated from message guardianai.v1.analytics.FraudAnalyticsResponse
 */
export type FraudAnalyticsResponseJson = {
  /**
   * @generated from field: int64 total_cases = 1;
   */
  totalCases?: string;

  /**
   * @generated from field: int64 resolved_cases = 2;
   */
  resolvedCases?: string;

  /**
   * @generated from field: int64 pending_cases = 3;
   */
  pendingCases?: string;

  /**
   * @generated from field: double detection_rate = 4;
   */
  detectionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, int64> by_type = 5;
   */
  byType?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> by_region = 6;
   */
  byRegion?: { [key: string]: string };

  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint trend = 7;
   */
  trend?: TimeSeriesPointJson[];
};

/**
 * Describes the message guardianai.v1.analytics.FraudAnalyticsResponse.
 * Use `create(FraudAnalyticsResponseSchema)` to create a new message.
 */
export const FraudAnalyticsResponseSchema: GenMessage<FraudAnalyticsResponse, {jsonType: FraudAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 9);

/**
 * @generated from message guardianai.v1.analytics.TrendDataRequest
 */
export type TrendDataRequest = Message<"guardianai.v1.analytics.TrendDataRequest"> & {
  /**
   * @generated from field: string metric = 1;
   */
  metric: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime: bigint;

  /**
   * "hour", "day", "week"
   *
   * @generated from field: string granularity = 4;
   */
  granularity: string;
};

/**
 * @generated from message guardianai.v1.analytics.TrendDataRequest
 */
export type TrendDataRequestJson = {
  /**
   * @generated from field: string metric = 1;
   */
  metric?: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime?: string;

  /**
   * "hour", "day", "week"
   *
   * @generated from field: string granularity = 4;
   */
  granularity?: string;
};

/**
 * Describes the message guardianai.v1.analytics.TrendDataRequest.
 * Use `create(TrendDataRequestSchema)` to create a new message.
 */
export const TrendDataRequestSchema: GenMessage<TrendDataRequest, {jsonType: TrendDataRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 10);

/**
 * @generated from message guardianai.v1.analytics.TrendDataResponse
 */
export type TrendDataResponse = Message<"guardianai.v1.analytics.TrendDataResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint data = 1;
   */
  data: TimeSeriesPoint[];

  /**
   * @generated from field: double slope = 2;
   */
  slope: number;

  /**
   * "up", "down", "stable"
   *
   * @generated from field: string direction = 3;
   */
  direction: string;
};

/**
 * @generated from message guardianai.v1.analytics.TrendDataResponse
 */
export type TrendDataResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint data = 1;
   */
  data?: TimeSeriesPointJson[];

  /**
   * @generated from field: double slope = 2;
   */
  slope?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * "up", "down", "stable"
   *
   * @generated from field: string direction = 3;
   */
  direction?: string;
};

/**
 * Describes the message guardianai.v1.analytics.TrendDataResponse.
 * Use `create(TrendDataResponseSchema)` to create a new message.
 */
export const TrendDataResponseSchema: GenMessage<TrendDataResponse, {jsonType: TrendDataResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 11);

/**
 * @generated from message guardianai.v1.analytics.PredictionRequest
 */
export type PredictionRequest = Message<"guardianai.v1.analytics.PredictionRequest"> & {
  /**
   * @generated from field: string metric = 1;
   */
  metric: string;

  /**
   * @generated from field: int32 forecast_periods = 2;
   */
  forecastPeriods: number;
};

/**
 * @generated from message guardianai.v1.analytics.PredictionRequest
 */
export type PredictionRequestJson = {
  /**
   * @generated from field: string metric = 1;
   */
  metric?: string;

  /**
   * @generated from field: int32 forecast_periods = 2;
   */
  forecastPeriods?: number;
};

/**
 * Describes the message guardianai.v1.analytics.PredictionRequest.
 * Use `create(PredictionRequestSchema)` to create a new message.
 */
export const PredictionRequestSchema: GenMessage<PredictionRequest, {jsonType: PredictionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 12);

/**
 * @generated from message guardianai.v1.analytics.PredictionResponse
 */
export type PredictionResponse = Message<"guardianai.v1.analytics.PredictionResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint predictions = 1;
   */
  predictions: TimeSeriesPoint[];

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;
};

/**
 * @generated from message guardianai.v1.analytics.PredictionResponse
 */
export type PredictionResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.analytics.TimeSeriesPoint predictions = 1;
   */
  predictions?: TimeSeriesPointJson[];

  /**
   * @generated from field: double confidence = 2;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.analytics.PredictionResponse.
 * Use `create(PredictionResponseSchema)` to create a new message.
 */
export const PredictionResponseSchema: GenMessage<PredictionResponse, {jsonType: PredictionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 13);

/**
 * @generated from message guardianai.v1.analytics.GenerateReportRequest
 */
export type GenerateReportRequest = Message<"guardianai.v1.analytics.GenerateReportRequest"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * @generated from field: int64 start_date = 2;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 end_date = 3;
   */
  endDate: bigint;

  /**
   * @generated from field: repeated string include_sections = 4;
   */
  includeSections: string[];

  /**
   * "pdf", "csv", "json"
   *
   * @generated from field: string format = 5;
   */
  format: string;
};

/**
 * @generated from message guardianai.v1.analytics.GenerateReportRequest
 */
export type GenerateReportRequestJson = {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType?: string;

  /**
   * @generated from field: int64 start_date = 2;
   */
  startDate?: string;

  /**
   * @generated from field: int64 end_date = 3;
   */
  endDate?: string;

  /**
   * @generated from field: repeated string include_sections = 4;
   */
  includeSections?: string[];

  /**
   * "pdf", "csv", "json"
   *
   * @generated from field: string format = 5;
   */
  format?: string;
};

/**
 * Describes the message guardianai.v1.analytics.GenerateReportRequest.
 * Use `create(GenerateReportRequestSchema)` to create a new message.
 */
export const GenerateReportRequestSchema: GenMessage<GenerateReportRequest, {jsonType: GenerateReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 14);

/**
 * @generated from message guardianai.v1.analytics.GenerateReportResponse
 */
export type GenerateReportResponse = Message<"guardianai.v1.analytics.GenerateReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string download_url = 3;
   */
  downloadUrl: string;
};

/**
 * @generated from message guardianai.v1.analytics.GenerateReportResponse
 */
export type GenerateReportResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string download_url = 3;
   */
  downloadUrl?: string;
};

/**
 * Describes the message guardianai.v1.analytics.GenerateReportResponse.
 * Use `create(GenerateReportResponseSchema)` to create a new message.
 */
export const GenerateReportResponseSchema: GenMessage<GenerateReportResponse, {jsonType: GenerateReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 15);

/**
 * @generated from message guardianai.v1.analytics.GetReportRequest
 */
export type GetReportRequest = Message<"guardianai.v1.analytics.GetReportRequest"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;
};

/**
 * @generated from message guardianai.v1.analytics.GetReportRequest
 */
export type GetReportRequestJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;
};

/**
 * Describes the message guardianai.v1.analytics.GetReportRequest.
 * Use `create(GetReportRequestSchema)` to create a new message.
 */
export const GetReportRequestSchema: GenMessage<GetReportRequest, {jsonType: GetReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 16);

/**
 * @generated from message guardianai.v1.analytics.ReportResponse
 */
export type ReportResponse = Message<"guardianai.v1.analytics.ReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string report_type = 2;
   */
  reportType: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 completed_at = 5;
   */
  completedAt: bigint;

  /**
   * @generated from field: string download_url = 6;
   */
  downloadUrl: string;

  /**
   * @generated from field: int64 expires_at = 7;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.analytics.ReportResponse
 */
export type ReportResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string report_type = 2;
   */
  reportType?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 completed_at = 5;
   */
  completedAt?: string;

  /**
   * @generated from field: string download_url = 6;
   */
  downloadUrl?: string;

  /**
   * @generated from field: int64 expires_at = 7;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.analytics.ReportResponse.
 * Use `create(ReportResponseSchema)` to create a new message.
 */
export const ReportResponseSchema: GenMessage<ReportResponse, {jsonType: ReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 17);

/**
 * @generated from message guardianai.v1.analytics.ListReportsRequest
 */
export type ListReportsRequest = Message<"guardianai.v1.analytics.ListReportsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string report_type_filter = 3;
   */
  reportTypeFilter: string;
};

/**
 * @generated from message guardianai.v1.analytics.ListReportsRequest
 */
export type ListReportsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string report_type_filter = 3;
   */
  reportTypeFilter?: string;
};

/**
 * Describes the message guardianai.v1.analytics.ListReportsRequest.
 * Use `create(ListReportsRequestSchema)` to create a new message.
 */
export const ListReportsRequestSchema: GenMessage<ListReportsRequest, {jsonType: ListReportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 18);

/**
 * @generated from message guardianai.v1.analytics.ListReportsResponse
 */
export type ListReportsResponse = Message<"guardianai.v1.analytics.ListReportsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.analytics.ReportResponse reports = 1;
   */
  reports: ReportResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.analytics.ListReportsResponse
 */
export type ListReportsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.analytics.ReportResponse reports = 1;
   */
  reports?: ReportResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.analytics.ListReportsResponse.
 * Use `create(ListReportsResponseSchema)` to create a new message.
 */
export const ListReportsResponseSchema: GenMessage<ListReportsResponse, {jsonType: ListReportsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 19);

/**
 * @generated from message guardianai.v1.analytics.MetricsRequest
 */
export type MetricsRequest = Message<"guardianai.v1.analytics.MetricsRequest"> & {
  /**
   * @generated from field: repeated string metric_names = 1;
   */
  metricNames: string[];

  /**
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.analytics.MetricsRequest
 */
export type MetricsRequestJson = {
  /**
   * @generated from field: repeated string metric_names = 1;
   */
  metricNames?: string[];

  /**
   * @generated from field: string period = 2;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.analytics.MetricsRequest.
 * Use `create(MetricsRequestSchema)` to create a new message.
 */
export const MetricsRequestSchema: GenMessage<MetricsRequest, {jsonType: MetricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 20);

/**
 * @generated from message guardianai.v1.analytics.MetricsResponse
 */
export type MetricsResponse = Message<"guardianai.v1.analytics.MetricsResponse"> & {
  /**
   * @generated from field: map<string, double> values = 1;
   */
  values: { [key: string]: number };

  /**
   * percentage change from previous period
   *
   * @generated from field: map<string, double> changes = 2;
   */
  changes: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.analytics.MetricsResponse
 */
export type MetricsResponseJson = {
  /**
   * @generated from field: map<string, double> values = 1;
   */
  values?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

  /**
   * percentage change from previous period
   *
   * @generated from field: map<string, double> changes = 2;
   */
  changes?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };
};

/**
 * Describes the message guardianai.v1.analytics.MetricsResponse.
 * Use `create(MetricsResponseSchema)` to create a new message.
 */
export const MetricsResponseSchema: GenMessage<MetricsResponse, {jsonType: MetricsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 21);

/**
 * @generated from message guardianai.v1.analytics.RealTimeMetricsRequest
 */
export type RealTimeMetricsRequest = Message<"guardianai.v1.analytics.RealTimeMetricsRequest"> & {
  /**
   * @generated from field: repeated string metric_names = 1;
   */
  metricNames: string[];
};

/**
 * @generated from message guardianai.v1.analytics.RealTimeMetricsRequest
 */
export type RealTimeMetricsRequestJson = {
  /**
   * @generated from field: repeated string metric_names = 1;
   */
  metricNames?: string[];
};

/**
 * Describes the message guardianai.v1.analytics.RealTimeMetricsRequest.
 * Use `create(RealTimeMetricsRequestSchema)` to create a new message.
 */
export const RealTimeMetricsRequestSchema: GenMessage<RealTimeMetricsRequest, {jsonType: RealTimeMetricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 22);

/**
 * @generated from message guardianai.v1.analytics.RealTimeMetricsResponse
 */
export type RealTimeMetricsResponse = Message<"guardianai.v1.analytics.RealTimeMetricsResponse"> & {
  /**
   * @generated from field: map<string, double> values = 1;
   */
  values: { [key: string]: number };

  /**
   * @generated from field: int64 timestamp = 2;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.analytics.RealTimeMetricsResponse
 */
export type RealTimeMetricsResponseJson = {
  /**
   * @generated from field: map<string, double> values = 1;
   */
  values?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

  /**
   * @generated from field: int64 timestamp = 2;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.analytics.RealTimeMetricsResponse.
 * Use `create(RealTimeMetricsResponseSchema)` to create a new message.
 */
export const RealTimeMetricsResponseSchema: GenMessage<RealTimeMetricsResponse, {jsonType: RealTimeMetricsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 23);

/**
 * Export Report Messages
 *
 * @generated from message guardianai.v1.analytics.ExportReportRequest
 */
export type ExportReportRequest = Message<"guardianai.v1.analytics.ExportReportRequest"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * "pdf", "csv", "json"
   *
   * @generated from field: string format = 2;
   */
  format: string;

  /**
   * @generated from field: int64 start_date = 3;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 end_date = 4;
   */
  endDate: bigint;
};

/**
 * Export Report Messages
 *
 * @generated from message guardianai.v1.analytics.ExportReportRequest
 */
export type ExportReportRequestJson = {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType?: string;

  /**
   * "pdf", "csv", "json"
   *
   * @generated from field: string format = 2;
   */
  format?: string;

  /**
   * @generated from field: int64 start_date = 3;
   */
  startDate?: string;

  /**
   * @generated from field: int64 end_date = 4;
   */
  endDate?: string;
};

/**
 * Describes the message guardianai.v1.analytics.ExportReportRequest.
 * Use `create(ExportReportRequestSchema)` to create a new message.
 */
export const ExportReportRequestSchema: GenMessage<ExportReportRequest, {jsonType: ExportReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 24);

/**
 * @generated from message guardianai.v1.analytics.ExportReportResponse
 */
export type ExportReportResponse = Message<"guardianai.v1.analytics.ExportReportResponse"> & {
  /**
   * @generated from field: string download_url = 1;
   */
  downloadUrl: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt: bigint;

  /**
   * @generated from field: bool success = 4;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.analytics.ExportReportResponse
 */
export type ExportReportResponseJson = {
  /**
   * @generated from field: string download_url = 1;
   */
  downloadUrl?: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename?: string;

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt?: string;

  /**
   * @generated from field: bool success = 4;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.analytics.ExportReportResponse.
 * Use `create(ExportReportResponseSchema)` to create a new message.
 */
export const ExportReportResponseSchema: GenMessage<ExportReportResponse, {jsonType: ExportReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_analytics_analytics, 25);

/**
 * @generated from service guardianai.v1.analytics.AnalyticsService
 */
export const AnalyticsService: GenService<{
  /**
   * Dashboard analytics
   *
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetDashboardAnalytics
   */
  getDashboardAnalytics: {
    methodKind: "unary";
    input: typeof DashboardAnalyticsRequestSchema;
    output: typeof DashboardAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetUserAnalytics
   */
  getUserAnalytics: {
    methodKind: "unary";
    input: typeof UserAnalyticsRequestSchema;
    output: typeof UserAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetFraudAnalytics
   */
  getFraudAnalytics: {
    methodKind: "unary";
    input: typeof FraudAnalyticsRequestSchema;
    output: typeof FraudAnalyticsResponseSchema;
  },
  /**
   * Trend analysis
   *
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetTrendData
   */
  getTrendData: {
    methodKind: "unary";
    input: typeof TrendDataRequestSchema;
    output: typeof TrendDataResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetPredictions
   */
  getPredictions: {
    methodKind: "unary";
    input: typeof PredictionRequestSchema;
    output: typeof PredictionResponseSchema;
  },
  /**
   * Reports
   *
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GenerateReport
   */
  generateReport: {
    methodKind: "unary";
    input: typeof GenerateReportRequestSchema;
    output: typeof GenerateReportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetReport
   */
  getReport: {
    methodKind: "unary";
    input: typeof GetReportRequestSchema;
    output: typeof ReportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.ListReports
   */
  listReports: {
    methodKind: "unary";
    input: typeof ListReportsRequestSchema;
    output: typeof ListReportsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.ExportReport
   */
  exportReport: {
    methodKind: "unary";
    input: typeof ExportReportRequestSchema;
    output: typeof ExportReportResponseSchema;
  },
  /**
   * Metrics
   *
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetMetrics
   */
  getMetrics: {
    methodKind: "unary";
    input: typeof MetricsRequestSchema;
    output: typeof MetricsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.analytics.AnalyticsService.GetRealTimeMetrics
   */
  getRealTimeMetrics: {
    methodKind: "unary";
    input: typeof RealTimeMetricsRequestSchema;
    output: typeof RealTimeMetricsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_analytics_analytics, 0);

